module.exports = __webpack_public_path__ + "img/d3aad03e-034a-4ac2-82ba-6479a7eb5190.d7ef1091.png";